export const normalizeName = (value: string) => {
  return value.replace(/[^А-Яа-яA-Za-z\s]/g,'')
}
